import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { AccordionService } from '../services/accordion.service';

@Component({
  selector: 'app-claim-location-search',
  templateUrl: './claim-location-search.component.html',
  styleUrls: ['./claim-location-search.component.scss']
})
export class ClaimLocationSearchComponent
  implements OnInit {

  @Input() public group: FormGroup;
  @Input() public accordionGroupName: string; // = 'location';

  constructor(private accordionService: AccordionService) { }

  ngOnInit() {
    this.accordionService.addFormControl(this.accordionGroupName, this.group, 'lossAddressType', 'policyholder');
    ['lossAddress1', 'lossPostcode']
      .forEach(name => this.accordionService.addFormControl(this.accordionGroupName, this.group, name));
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/claim/claim-list/claim-location-search/claim-location-search.component.ts